import { useEffect, useRef } from "react";

export function useLiveReload(load, every = 30000) {
  const ref = useRef(load);
  ref.current = load;
  useEffect(() => {
    const run = () => { if (document.visibilityState === "visible") ref.current(); };
    const t = setInterval(run, every);
    document.addEventListener("visibilitychange", run);
    window.addEventListener("focus", run);
    return () => { clearInterval(t); document.removeEventListener("visibilitychange", run); window.removeEventListener("focus", run); };
  }, [every]);
}
